import { Ats } from "../graphql";
import useCurrentUser from "./useCurrentUser";
import { useIsScreenOrgAtsConnected } from "./useIsScreenOrgAtsConnected";

/**
 * Determines whether position is required on AI interviewer setup/edit forms.
 *
 * - Workday (ATS-integrated): required
 * - ATS-less orgs: required
 * - Other ATS-integrated orgs (Greenhouse, Ashby): hidden
 */
export const useIsScreenPositionRequired = (): boolean => {
  const currentUser = useCurrentUser();
  const isAtsConnected = useIsScreenOrgAtsConnected();
  const ats = currentUser?.organization?.ats;
  const isWorkday = ats === Ats.Workday || ats === Ats.MergeWorkday;

  return isWorkday || !isAtsConnected;
};
